<ol class="breadcrumb page-breadcrumb">
    <li class="breadcrumb-item">
        <a href="javascript:void(0);" [routerLink]="['/admin/home']">Home</a>
    </li>
    <li class="breadcrumb-item active">Auditoria de Acessos</li>
    <li class="position-absolute pos-top pos-right d-none d-sm-block"><span class="js-get-date"></span></li>
</ol>
<div class="row">
  <div class="col-md-12">
    <div id="panel-8" class="panel">
      <div class="panel-hdr">
        <h2>Filtro</h2>
      </div>
      <div class="panel-container show">
        <div class="panel-content">
            <div class="form-row">
              <div class="col-6 mb-3">
                  <span role="status" aria-hidden="true" class="spinner-border spinner-border-sm pull-left mr-2 text-primary" *ngIf="flagSearchUser"></span>
                  <span class="text-primary pull-left" *ngIf="flagSearchUser">Carregando usuários</span>
                  <label class="form-label" for="userId">Usuário <span class="text-danger">*</span> </label>
                  <div class="ng-autocomplete w-100">
                      <ng-autocomplete
                          [data]="userDataList"
                          searchKeyword="name"
                          placeholder="Selecione o usuário"
                          (selected)='setUser($event)'
                          [itemTemplate]="itemTemplate"
                          [notFoundTemplate]="notFoundTemplate">
                      </ng-autocomplete>

                      <ng-template #itemTemplate let-item>
                          <a [innerHTML]="item.name"></a>
                      </ng-template>

                      <ng-template #notFoundTemplate let-notFound>
                          <div [innerHTML]="notFound"></div>
                      </ng-template>
                  </div>
              </div>
              <div class="col-3 mb-3">
                <label class="form-label" for="startDate">Data inicial</label>
                <input class="form-control" id="startDate" type="date" name="date" placeholder="Data inicial" value="2025-01-01" (change)="setStartDate($event)">
                <!-- <input class="form-control" id="example-date" type="date" name="date" value="2023-07-23"> -->
              </div>
              <div class="col-3 mb-3">
                <label class="form-label" for="endDate">Data final</label>
                <input class="form-control" id="endDate" type="date" name="endDate" placeholder="Data final" value="2025-01-31" (change)="setEndDate($event)">
              </div>
            </div>
            <div class="form-row" *ngIf="userId > 0">
              <hr>
              <div class="col-6">
                <div class="alert alert-primary">
                  <div class="d-flex flex-start w-100">
                    <div class="mr-2 hidden-md-down">
                      <span class="icon-stack icon-stack-lg">
                        <i class="base base-6 icon-stack-3x opacity-100 color-primary-500"></i>
                        <i class="base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical"></i>
                        <i class="ni ni-blog-read icon-stack-1x opacity-100 color-white"></i>
                      </span>
                    </div>
                    <div class="d-flex flex-fill">
                      <div class="flex-fill">
                        <div class="col-12 mb-3">
                          <span class="h5 mb-3">Dados do User</span>
                          <div class="form-row mb-3">
                            <div class="col-md-6">
                              <div class="form-group">
                                <label class="form-label text-muted" for="userName">Nome</label>
                                <input type="text" id="userName" class="form-control" disabled="" [value]="userData?.name">
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <label class="form-label text-muted" for="userEmail">E-mail</label>
                                <input type="text" id="userEmail" class="form-control" disabled="" [value]="userData?.email">
                              </div>
                            </div>
                            <div class="col-md-3">
                              <div class="form-group">
                                <label class="form-label text-muted" for="userPhone">Telefone</label>
                                <input type="text" id="userPhone" class="form-control" disabled="" [value]="userData?.phoneNumber">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
        <div class="panel-content border-faded border-left-0 border-right-0 border-bottom-0 d-flex flex-row">
          <button class="btn btn-primary ml-auto" type="button" [disabled]="flagFiltering" (click)="getUserAudit(null)">
            <span *ngIf="flagFiltering" class="spinner-border spinner-border-sm mr-1"></span>
            Filtrar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-xl-12">
    <div id="panel-8" class="panel">
      <div class="panel-hdr bg-primary-600 bg-primary-gradient">
        <h2>Auditoria de Acessos</h2>
      </div>
      <div class="panel-container show">
        <div class="panel-content py-2 rounded-bottom border-faded border-left-0 border-right-0 border-bottom-0 text-muted d-flex">
          <div class="col-sm-12" *ngIf="!showTable">
            <div class="alert alert-warning m-2" role="alert">{{returnMessage}}</div>
          </div>
          <div class="col-sm-12" *ngIf="showTable">
            <managed-table [dataTitle]="" [rows]="list" [columns]="columns" [hasActions]="false" [ngTableFiltering]="true" [showFilterRow]="false"
              [previewEnable]="false" [editEnable]="false" [deleteEnable]="false" [hasFilter]="true">
            </managed-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
